import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ACFindingsIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12.1675 4.03711C12.3436 3.97966 12.5358 3.98897 12.7065 4.06543L19.9565 7.31543L20.0473 7.36426C20.2499 7.49079 20.3818 7.70783 20.3979 7.9502L19.6499 8C20.3349 7.95433 20.393 7.95022 20.3979 7.9502L20.3989 7.95215V7.96289C20.3993 7.96969 20.4002 7.97933 20.4009 7.99121C20.4022 8.01535 20.4039 8.04976 20.4057 8.09375C20.4096 8.18243 20.4139 8.31064 20.4165 8.47168C20.4216 8.79352 20.4194 9.25025 20.3911 9.79688C20.3346 10.8859 20.173 12.3534 19.7456 13.833C19.3196 15.3076 18.6147 16.8457 17.438 18.0225C16.2417 19.2187 14.5975 20 12.3999 20C10.2023 20 8.558 19.2187 7.3618 18.0225C6.18511 16.8457 5.48017 15.3076 5.05418 13.833C4.62676 12.3534 4.46515 10.8859 4.40867 9.79688C4.38033 9.25026 4.37818 8.79352 4.38328 8.47168C4.38584 8.31064 4.39021 8.18243 4.39402 8.09375C4.39591 8.04977 4.39757 8.01536 4.39891 7.99121C4.39956 7.97934 4.40044 7.96969 4.40086 7.96289C4.40107 7.95947 4.4017 7.95617 4.40184 7.9541V7.95117C4.40184 7.95117 4.40169 7.95012 5.14988 8L4.40184 7.95117C4.4203 7.67427 4.59001 7.42895 4.84324 7.31543L12.0932 4.06543L12.1675 4.03711ZM5.88328 8.49316V9.02637C5.88644 9.23213 5.89355 9.46473 5.90672 9.71875C5.95962 10.739 6.11058 12.0843 6.49559 13.417C6.88208 14.7548 7.48978 16.0293 8.42234 16.9619C9.33546 17.875 10.5976 18.5 12.3999 18.5C14.2022 18.5 15.4643 17.875 16.3774 16.9619C17.31 16.0293 17.9177 14.7548 18.3042 13.417C18.6892 12.0843 18.8401 10.739 18.893 9.71875C18.9194 9.21088 18.9211 8.78846 18.9165 8.49512L18.9155 8.49316L12.3999 5.57129L5.88328 8.49316Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M11.4 15C11.4 14.4478 11.8478 14 12.4 14C12.9522 14 13.4 14.4478 13.4 15C13.4 15.5522 12.9522 16 12.4 16C11.8478 16 11.4 15.5522 11.4 15Z"
        fill="currentColor"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M11.4 11V9C11.4 8.44772 11.8477 8 12.4 8C12.9523 8 13.4 8.44772 13.4 9V11C13.4 11.5523 12.9523 12 12.4 12C11.8477 12 11.4 11.5523 11.4 11Z"
        fill="currentColor"
      />
    </svg>
  );
};
